/**
 * Created by Leszek.Hanusiak on 2018-01-05.
 */
/**
 * Validation method that test if the field is valid against a email address.
 */
export var email = function (emailAddressToVerify) {
    var emailAddress = new RegExp('^(([A-Za-z0-9]+_+)|([A-Za-z0-9]+\\\\-+)|([A-Za-z0-9]+\\\\.+)|([A-Za-z0-9]+\\\\++))*[_A-Za-z0-9]+@((\\\\w+\\\\-+)|(\\\\w+\\\\.))*\\\\w{1,63}\\\\.[a-zA-Z]{2,6}$');
    return emailAddress.test(emailAddressToVerify);
};
